// Feature flags em runtime para o core moderno. Fonte ÚNICA: o objeto
// global `Flags` (src/js/flags.js), carregado pelo index antes do bundle
// e populado por `Flags.load()` no boot (src/js/page.js). Aqui só
// delegamos — manter um segundo store aqui gerava divergência (o store
// deste módulo nunca era carregado, então toda flag saía desligada).
// Ver MODERNIZACAO.md, seção Feature Flags.

export function isEnabled(nome: string): boolean {
  return typeof Flags !== 'undefined' && Flags.isEnabled(nome)
}
